/* eslint-disable @nx/enforce-module-boundaries */
import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from '@mybridge/ui/text';
import { Divider } from '@mybridge/ui/divider';
import { Button } from '@mybridge/ui/button';
import { Radio, RadioGroup } from '@mybridge/ui/radio';
import { LanguageDropdown } from 'v4/components/language-dropdown';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
} from '@mybridge/ui/accordion';
import { Input } from '@mybridge/ui/input';
import { Textarea } from '@mybridge/ui/text-area';
import { Tag, TagLabel, TagLeftIcon } from '@mybridge/ui/tag';
import { Checkbox } from '@mybridge/ui/checkbox';
import QuestionCards from '../components/question-cards';
import styles from './create.module.scss';
import {
  ArrowDownFilledIcon,
  ArrowUpFilledIcon,
  ChevronDown,
  ChevronUp,
  EditIconSuggestions,
  TagPlus,
  TagTick,
} from '@mybridge/icons';
import {
  getAllCompanyPages,
  getCompanyPageInfo,
} from '../../../../../store/actions/companyPages.actions';
import { isEmpty } from 'lodash';
import { Card, CardBody } from '@mybridge/ui/card';
import { HStack, Stack, Box } from '@mybridge/ui/layout';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from '@mybridge/ui/form-control';
import { getJobScreeningQuestions } from 'v4/store/actions/companyJobs.actions';
import _ from 'lodash';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import { UpdatePartialJob } from 'v4/store/actions/companyJobs.actions';
import { useForm } from 'react-hook-form';
import { CreateJobsContext } from 'v4/components/company/Layout/context';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@mybridge/ui';
import { useDisclosure } from '@mybridge/ui';
import { EmailsTagsInput } from 'v4/components/email-input';
import { WebsitesTagsInput } from 'v4/components/website-input';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

const ApplySection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const direction = useDirection();
  const screeningModalDisc = useDisclosure();
  const {
    createOrUpdateJob,
    createJobLoading,
    updateJobLoading,
    isEdit,
    setSection,
    jobDetails,
    setJobDetails,
    screeningQuestions: questions,
  } = useContext(CreateJobsContext);

  const { screeningQuestions, loading } = useSelector(
    (state) => state.companyJobs
  );
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [emailError, setEmailError] = useState(null);
  const [externalError, setExternalError] = useState(null); 
  const [howToApply, setHowToApply] = useState('EMAIL');
  // const [selectedQuestions, setSelectedQuestions] = useState(() =>
  //   screeningQuestions?.results?.map((item) => {
  //     return { selected: false, item: item };
  //   })
  // );
  // 
  // const [editQuestions, setEditQuestions] = useState(() =>
  //   screeningQuestions?.results?.map((item) => {
  //     return { selected: false, item: item };
  //   })
  // );

  const resumeQuestion = {
    id: 'resume',
    name: 'Resume',
    questions: [
      {
        id: 'resume-q',
        question: 'Include an updated resume',
        question_original: 'Include an updated resume',
        ideal_answer_text: null,
        ideal_answer_type: 'bool',
        ideal_answer_value: 'Yes',
        is_must_have: false,
        place_holder_value: null
      }
    ]
  };

  const getUpdatedQuestionsList = (results) => {
    if (!results) return [];
    const hasResume = results.some(q => q.name === 'Resume');
    return hasResume ? results : [...results, resumeQuestion];
  };

  const [selectedQuestions, setSelectedQuestions] = useState(() =>
    getUpdatedQuestionsList(screeningQuestions?.results)?.map((item) => {
      return { selected: false, item: item };
    })
  );

  const [editQuestions, setEditQuestions] = useState(() =>
    getUpdatedQuestionsList(screeningQuestions?.results)?.map((item) => {
      return { selected: false, item: item };
    })
  );
  const [savedQuestions, setSavedQuestions] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      how_to_apply: jobDetails?.how_to_apply || ""
    },
    mode: "onSubmit"
  });

  const howToApplyWatch = watch('how_to_apply');
  const howToApplyTextWatch = watch('how_to_apply_text');

  const howToApplys =
    typeof jobDetails?.how_to_apply_text === 'string'
      ? JSON.parse(jobDetails?.how_to_apply_text.replace(/'/g, '"')) // Replace single quotes with double quotes and parse
      : jobDetails?.how_to_apply_text; // Leave as is if not a string

  const [email, setEmail] = useState();
  const [external, setExternal] = useState();
  useEffect(() => {
    setJobDetails((prevDetails) => ({
      ...prevDetails,
      how_to_apply: howToApply,
      // how_to_apply_text: howToApply === 'EMAIL' ? email : external,
    }));
  }, [howToApply, email, external]);
  useEffect(() => {
    setHowToApply(howToApplyWatch);
    setJobDetails({
      ...jobDetails,
      how_to_apply: howToApplyWatch,
      // how_to_apply_text: howToApplyTextWatch,
    });
    // Clear errors when switching between application methods
    setEmailError(null);
    setExternalError(null);
  }, [howToApplyWatch, howToApplyTextWatch]);

  useEffect(() => {
    dispatch(getAllCompanyPages());
    dispatch(getJobScreeningQuestions());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (jobDetails?.how_to_apply) {
      setHowToApply(jobDetails?.how_to_apply);
    }
  }, [jobDetails]);

  useEffect(() => {
    if (jobDetails?.how_to_apply === 'EMAIL' && howToApplys) {
      setEmail(howToApplys);
    } else if (userProfileInfo?.email && !email) {
      setEmail([userProfileInfo.email]);
    }
  }, [userProfileInfo, jobDetails?.how_to_apply, howToApplys]);

  useEffect(() => {
    if (jobDetails?.how_to_apply === 'EXTERNAL' && howToApplys) {
      setExternal(howToApplys);
    }
  }, [jobDetails?.how_to_apply, howToApplys]);

  // useEffect(() => {
  //   if (jobDetails?.screening_question?.length) {
  //     const newArray1 = _.cloneDeep(editQuestions);
  //     jobDetails?.screening_question?.forEach((obj2, i) => {
  //       const index = _.findIndex(newArray1, { item: { name: obj2.name } });
  //       // const index = _.findIndex(newArray1, { name: obj2.name });
  // 
  //       if (index !== -1) {
  //         newArray1[index] = {
  //           selected: true,
  //           item: obj2,
  //         };
  //       }
  //     });
  //     setSelectedQuestions(newArray1);
  //     setSavedQuestions(true);
  //     // setSelectedQuestions(
  //     //   jobDetails?.screening_question?.map((item) => {
  //     //     return { selected: true, item: item };
  //     //   })
  //     // );
  //   } else {
  //     setSelectedQuestions(
  //       screeningQuestions?.results?.map((item) => {
  //         return { selected: false, item: item };
  //       })
  //     );
  //   }
  // }, [screeningQuestions]);

  useEffect(() => {
    const updatedList = getUpdatedQuestionsList(screeningQuestions?.results);
    const updatedEditQuestions = updatedList.map((item) => ({ selected: false, item }));
    setEditQuestions(updatedEditQuestions);

    if (jobDetails?.screening_question?.length) {
      const newArray1 = _.cloneDeep(updatedEditQuestions);
      jobDetails?.screening_question?.forEach((obj2, i) => {
        const index = _.findIndex(newArray1, { item: { name: obj2.name } });

        if (index !== -1) {
          newArray1[index] = {
            selected: true,
            item: obj2,
          };
        }
      });
      setSelectedQuestions(newArray1);
      setSavedQuestions(true);
    } else {
      setSelectedQuestions(
        updatedList.map((item) => {
          return { selected: false, item: item };
        })
      );
    }
  }, [screeningQuestions, jobDetails?.screening_question]);

  const onClickBack = (e) => {
    e.preventDefault();
    setSection(2);
  };

  const handleRemoveSelected = (item) => {
    setSelectedQuestions(
      selectedQuestions?.map((selectedquestion, j) => {
        if (item.item.name === selectedquestion.item.name) {
          selectedquestion.selected = false;
        }
        return selectedquestion;
      })
    );
  };
  const handleSelectedQuestion = (item) => {
    setSelectedQuestions(
      selectedQuestions?.map((selectedquestion, j) => {
        if (item.item.name === selectedquestion?.item?.name) {
          selectedquestion = item;
        }
        return selectedquestion;
      })
    );
  };

  const onClickNext = (form) => {
    if (form.how_to_apply === 'EMAIL' && (!email || email.length === 0)) {
      // Set an error for email field
      setEmailError(t('createJob.emailIsRequired') || "Email is required");
      return;
    } else if (form.how_to_apply === 'EXTERNAL' && (!external || external.length === 0)) {
      // Set an error for website field
      setExternalError(t('createJob.correctWebsiteFormat') || "Please enter in correct website URL format");
      return;
    }
    // Clear any existing errors
    setEmailError(null);
    setExternalError(null);
    if (!(email?.length > 0 || external?.length > 0)) {
      return;
    }
    const payload = {
      body: {
        how_to_apply: form?.how_to_apply,
        how_to_apply_text: form?.how_to_apply === 'EMAIL' ? email : external,
        screening_question: jobDetails?.screening_question,
        qualify_application: Boolean(form?.qualify_application),
        // is_resume_required: Boolean(form?.is_resume_required)
        // is_resume_required: Boolean(selectedQuestions?.some(q => q.item.name === 'Resume' && q.selected))
        is_resume_required: Boolean(selectedQuestions?.some(q => q.item.name === 'Resume' && q.selected && q.item.questions?.[0]?.is_must_have))
      },
      id: jobDetails?.id,
      method: 'PUT',
    };
    createOrUpdateJob(payload);
  };

  const saveSelectedQuestions = () => {
    const pushArray = [];
    setSelectedQuestions(selectedQuestions);
    selectedQuestions?.forEach((selectedQuestion) => {
      if (selectedQuestion.selected === true) {
        pushArray.push(selectedQuestion?.item);
      }
    });

    // const uniqueArray = _.uniqBy(finalQuestions.reverse(), 'name').reverse();

    setJobDetails((state) => ({
      ...state,
      screening_question: pushArray,
    }));
  };

  useEffect(() => {
    const selectedCount = _.filter(selectedQuestions, {
      selected: true,
    }).length;
    // console.log('selectedCount', selectedCount);
    if (selectedCount === 0 && savedQuestions) {
      setSavedQuestions(false);
    }
  }, [selectedQuestions]);

  const hasBlankQuestion = selectedQuestions
    ?.filter((ques) => ques.selected)
    ?.some((ques) => {
      return ques?.item?.questions?.some((question) => {
        return (
          question.ideal_answer_text !== null &&
          (question.place_holder_value === null ||
            question.place_holder_value === undefined ||
            String(question.place_holder_value)?.trim() === '')
        );
      });
    });

  return (
    <>
      {!loading ? (
        <form onSubmit={handleSubmit(onClickNext)}>
          <Stack spacing={5} direction="column">
            {/* <Text fontSize="md" color="brandGray.700" fontWeight="semibold">
              How would you like people to apply?*
            </Text> */}
            <Stack spacing={5} direction="column" justifyContent="flex-start">
              <Card boxShadow="none" border=" 1px solid #E4E6EB" p={2}>
                <Radio
                  name="how_to_apply"
                  value="EMAIL"
                  defaultChecked={
                    jobDetails?.how_to_apply === 'EMAIL' ? true : false
                  }
                  isChecked={
                    jobDetails?.how_to_apply === 'EMAIL' ? true : false
                  }
                  {...register('how_to_apply', {
                    required: "Please select an application method"
                  })}
                  // onChange={setData}
                >
                  <Text fontSize="14px" color="#5B5B5B">
                    {t('createJob.applyWithMyBridgeProfile') || "Let candidates apply with their myBridge profile and notify me by email (recommended)"}
                  </Text>
                </Radio>
                {jobDetails?.how_to_apply === 'EMAIL' ? (
                  <Stack spacing={2}>
                    <FormControl
                      isInvalid={errors.how_to_apply_text?.type === 'pattern'|| emailError}
                    >
                      <FormLabel
                        mb={0}
                        mt={3}
                        fontSize="sm"
                        color="brandGray.30"
                        fontWeight="medium"
                        htmlFor="how_to_apply_text"
                      >
                        {t('profileDetails.email') || "Email"}*
                      </FormLabel>
                      <EmailsTagsInput
                        value={email}
                        onChange={(value) => {
                          setEmail(value);
                        }}
                      />

                      {errors.how_to_apply_text?.type === 'pattern' && (
                        <FormErrorMessage mt={0}>
                          {t('createPage.pleaseEnterValidEmail') || "Please enter a valid email"}
                        </FormErrorMessage>
                      )}
                      {emailError && (
                        <FormErrorMessage mt={0}>
                          {emailError}
                        </FormErrorMessage>
                      )}
                    </FormControl>
                    {jobDetails?.how_to_apply === 'EMAIL' && (
                      <Accordion allowMultiple>
                        <AccordionItem border="none">
                          {({ isExpanded }) => (
                            <>
                              <AccordionButton
                                border="1px solid #E4E6EB"
                                borderRadius="8px"
                              >
                                <Box as="span" flex="1" textAlign={direction === 'rtl' ? "right" : "left"}>
                                  {t('createJob.addScreeningQuestions') || "Add screening questions"}
                                </Box>
                                {isExpanded ? (
                                  <ChevronUp fontSize="12px" />
                                ) : (
                                  <ChevronDown fontSize="12px" />
                                )}
                              </AccordionButton>
                              <AccordionPanel pb={4} key="0" p={1}>
                                <Box mb={5}>
                                  <Checkbox
                                    my={0}
                                    key={21}
                                    color="brandGray.700"
                                    fontSize="md"
                                    value={jobDetails?.qualify_application}
                                    {...register('qualify_application', {
                                      required: false,
                                    })}
                                  >
                                    {t('createJob.qualificationSetting') || "Qualification setting: Filter out and send rejections to applicants who don’t meet any must-have qualifications."}
                                  </Checkbox>
                                  {/* <Checkbox
                                    my={0}
                                    key={21}
                                    color="brandGray.700"
                                    fontSize="md"
                                    value={jobDetails?.is_resume_required}
                                    {...register('is_resume_required', {
                                      required: false,
                                    })}
                                  >
                                    {"Resume setting: When checked, applicants cannot apply without attaching resume."}
                                  </Checkbox> */}
                                </Box>
                                {/* {screeningQuestions &&
                                  screeningQuestions?.results?.map(
                                    (question, index) => (
                                      <Tag
                                        size="lg"
                                        key={'tag-' + index}
                                        borderRadius="full"
                                        variant="solid"
                                        colorScheme="white"
                                        border="1px solid #D9D9D9"
                                        color="brandGray.700"
                                        cursor="pointer"
                                        transitionDuration="200ms"
                                        backgroundColor={
                                          selectedQuestions &&
                                          selectedQuestions[index]?.selected
                                            ? 'brandGray.300'
                                            : ''
                                        }
                                        mb={2}
                                        mr={2}
                                        onClick={() => {
                                          setSelectedQuestions(
                                            selectedQuestions?.map((selectedQuestion) => {
                                              if (question.name === selectedQuestion.item.name) {
                                                // Toggle the selected state
                                                const updatedSelected = !selectedQuestion.selected;
                                        
                                                // Map through `questions` array and add `question_original`
                                                const updatedQuestions = selectedQuestion?.item?.questions?.map((q) => ({
                                                  ...q,
                                                  question_original: question?.questions?.[0]?.question, // Add `question_original`
                                                }));
                                        
                                                return {
                                                  ...selectedQuestion,
                                                  selected: updatedSelected, // Update selected state
                                                  item: {
                                                    ...selectedQuestion.item,
                                                    questions: updatedQuestions, // Update questions with question_original
                                                  },
                                                };
                                              }
                                              return selectedQuestion;
                                            })
                                          );
                                        }}
                                      >
                                        {selectedQuestions &&
                                        selectedQuestions[index]?.selected ? (
                                          <TagLeftIcon
                                            boxSize="24px"
                                            color="#5B5B5B"
                                            as={TagTick}
                                          />
                                        ) : (
                                          <TagLeftIcon
                                            boxSize="24px"
                                            as={TagPlus}
                                          />
                                        )}

                                        <TagLabel>{question.name}</TagLabel>
                                      </Tag>
                                    )
                                  )} */}

                                {selectedQuestions &&
                                  selectedQuestions?.map(
                                    (selectedQuestion, index) => {
                                      const question = selectedQuestion.item;
                                      return (
                                        <Tag
                                          size="lg"
                                          key={'tag-' + index}
                                          borderRadius="full"
                                          variant="solid"
                                          colorScheme="white"
                                          border="1px solid #D9D9D9"
                                          color="brandGray.700"
                                          cursor="pointer"
                                          transitionDuration="200ms"
                                          backgroundColor={
                                            selectedQuestion.selected
                                              ? 'brandGray.300'
                                              : ''
                                          }
                                          mb={2}
                                          mr={2}
                                          onClick={() => {
                                            setSelectedQuestions(
                                              selectedQuestions?.map((sq) => {
                                                if (question.name === sq.item.name) {
                                                  // Toggle the selected state
                                                  const updatedSelected = !sq.selected;
                                          
                                                  // Map through `questions` array and add `question_original`
                                                  const updatedQuestions = sq?.item?.questions?.map((q) => ({
                                                    ...q,
                                                    question_original: question?.questions?.[0]?.question || q.question, // Add `question_original`
                                                  }));
                                          
                                                  return {
                                                    ...sq,
                                                    selected: updatedSelected, // Update selected state
                                                    item: {
                                                      ...sq.item,
                                                      questions: updatedQuestions, // Update questions with question_original
                                                    },
                                                  };
                                                }
                                                return sq;
                                              })
                                            );
                                          }}
                                        >
                                          {selectedQuestion.selected ? (
                                            <TagLeftIcon
                                              boxSize="24px"
                                              color="#5B5B5B"
                                              as={TagTick}
                                            />
                                          ) : (
                                            <TagLeftIcon
                                              boxSize="24px"
                                              as={TagPlus}
                                            />
                                          )}

                                          <TagLabel>{question.name}</TagLabel>
                                        </Tag>
                                      );
                                    }
                                  )}
                                <Divider mb={3} />
                                <Button
                                  type="button"
                                  bg="#868585"
                                  borderRadius="full"
                                  onClick={() => screeningModalDisc.onOpen()}
                                  rightIcon={
                                    savedQuestions && <EditIconSuggestions />
                                  }
                                  _hover={{ bg: '#616161' }}
                                >
                                  <Text
                                    borderRight={
                                      savedQuestions && '1px solid white'
                                    }
                                    color="#fff"
                                    pe={savedQuestions ? 3 : 0}
                                  >
                                    {' '}
                                    {savedQuestions
                                      ? t('createJob.editSelections') || 'Edit selections'
                                      : t('createJob.saveQuestions') || 'Save questions'}
                                  </Text>
                                </Button>
                              </AccordionPanel>
                            </>
                          )}
                        </AccordionItem>
                      </Accordion>
                    )}
                  </Stack>
                ) : (
                  ''
                )}
              </Card>
              <Card boxShadow="none" border="1px solid #E4E6EB" p={2}>
                <Radio
                  name="how_to_apply"
                  value="EXTERNAL"
                  {...register('how_to_apply', {
                    required: "Please select an application method"
                  })}
                  defaultChecked={
                    jobDetails?.how_to_apply === 'EXTERNAL' ? true : false
                  }
                  isChecked={
                    jobDetails?.how_to_apply === 'EXTERNAL' ? true : false
                  }
                >
                  <Text fontSize="14px" color="#5B5B5B">
                    {t('createJob.applyWithExternalSite') || "Direct applicants to an external site to apply"}
                  </Text>
                </Radio>
                {jobDetails?.how_to_apply === 'EXTERNAL' && (
                  <FormControl
                    isInvalid={errors.how_to_apply_text?.type === 'pattern' || externalError}
                  >
                    <FormLabel
                      mt={4}
                      fontSize="sm"
                      color="brandGray.30"
                      fontWeight="medium"
                      htmlFor="how_to_apply_text"
                    >
                      {t('createPage.website') || "Website"}*
                    </FormLabel>
                    <WebsitesTagsInput
                      value={external} // Pass the website state as an array
                      onChange={(value) => {
                        setExternal(value); // Update the website state
                      }}
                    />
                    {errors.how_to_apply_text?.type === 'pattern' ? (
                      <FormErrorMessage mt={0}>
                        {t('createJob.correctWebsiteFormat') || "Please enter in correct website URL format"}
                      </FormErrorMessage>
                    ) : (
                      ''
                    )}
                    {externalError && (
                      <FormErrorMessage mt={0}>
                        {externalError}
                      </FormErrorMessage>
                    )}
                  </FormControl>
                )}
              </Card>
              {errors.how_to_apply && (
                <Text color="red.500" fontSize="sm" mt={2}>
                  {errors.how_to_apply.message}
                </Text>
              )}
            </Stack>
          </Stack>
          <>
            {!isEdit && (
              <HStack mt={3} justifyContent="stretch">
                <Button
                  height="48px"
                  variant="secondary"
                  width="50%"
                  onClick={onClickBack}
                  borderRadius="full"
                  type="button"
                >
                  {t('buttons.back') || "Back"}
                </Button>
                <Button
                  height="48px"
                  variant="primary"
                  width="50%"
                  type="submit"
                  borderRadius="full"
                  isLoading={createJobLoading || updateJobLoading}
                  // onClick={onClickNext}
                >
                  {t('buttons.next') || "Next"}
                </Button>
              </HStack>
            )}
          </>
        </form>
      ) : (
        <HStack w="100%" justifyContent="center">
          <SectionLoader />
        </HStack>
      )}

      <Modal {...screeningModalDisc} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('createJob.screeningQuestions') || "Screening questions"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedQuestions?.filter((ques) => ques.selected).length > 0 && (
              <>
                {selectedQuestions
                  .filter((ques) => ques.selected)
                  .map((question, index) => (
                    <QuestionCards
                      item={question}
                      index={index}
                      key={index}
                      jobDetails={jobDetails}
                      // blockErrors={(e) => setQuestionErrors(e)}
                      onAnswerTextChange={(e) => handleSelectedQuestion(e)}
                      onDelete={(e) => handleRemoveSelected(e)}
                    />
                    // <></>
                  ))}
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <HStack justifyContent="flex-end" gap={3}>
              <Button borderRadius="full" onClick={() => screeningModalDisc.onClose()}>
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button 
                variant="primary"
                borderRadius="full"
                isDisabled={hasBlankQuestion}
                onClick={() => {
                  setSavedQuestions(true);
                  screeningModalDisc.onClose();
                  saveSelectedQuestions();
                }}
              >
                {t('buttons.save') || "Save"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ApplySection;
